import React, { useState } from "react";
import {
  Grid,
  Box,
  Typography,
  Avatar,
  Chip,
  TextField,
  Button,
  Dialog,
  DialogContent,
  FormControl, 
  MenuItem, 
  Select
} from "@mui/material";
import { CiCalendar } from "react-icons/ci";
import { FaAngleRight } from "react-icons/fa6";
import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined";
import StatusBadge from "components/badge/StatusBadge";
import CustomButton from "components/Button";
import moment from "moment";
import { useDispatch } from "store";
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";
import { useGetMyTaskHistoryQuery,useGetWorkflowDetailQuery,useApproveWorkflowTaskMutation,useRejectWorkflowTaskMutation } from "store/slices/apis/workFlowSlice";
import { useGetImplementationScheduleDetailQuery, useGetImplementationScheduleDocumentsQuery} from "store/slices/apis/masterScheduleSlice";
import { API_BASE_URL } from "config";
import WorkflowMetaCard from "components/WorkflowMetaCard";


const ViewSchedule = ({ open, onClose, cardData }) => {

  const dispatch = useDispatch();
  const [comment, setComment] = useState("");
  const [attachments, setAttachments] = useState([]);

  const [approveWorkItem, { isLoading }] = useApproveWorkflowTaskMutation();
  const [rejectWorkItem, { isLRejectLoading }] = useRejectWorkflowTaskMutation();

  const {
    data: historyResponse,
    isLoading: isHistoryLoading,
    error: historyError,
    } = useGetMyTaskHistoryQuery(
        { instanceId: cardData?.workflowInstanceId, type: cardData?.entityType },
        { skip: !cardData?.entityId }
  );
  // const {
  //   data: scheduleData,
  //   isLoading: isScheduleLoading,
  //   error: scheduleError,
  //   } = useGetImplementationScheduleDetailQuery(
  //       { id: cardData?.entityId },
  //       { skip: !cardData?.entityId }
  // );
    const {
    data: scheduleData,
    isLoading: isScheduleLoading,
    error: scheduleError,
    } = useGetWorkflowDetailQuery(
        cardData?.workflowId ,
        { skip: !cardData?.workflowId }
  );

   const {
     data: scheduleDocument,
     isLoading: isDocumentsLoading,
     error: documentError,
     } = useGetImplementationScheduleDocumentsQuery(
        { id: cardData?.entityId, type: cardData?.entityType },
        { skip: !cardData?.entityId }
  );



  // historyResponse?.data is assumed to be { workflowSteps: [...] }
  const workflowSteps = historyResponse?.data?.workflowSteps ?? [];
  const schedule = scheduleData?.data;
  const documents=scheduleDocument?.data;

  const getFormattedDate = (date) =>
    date ? moment(date).format("DD MMM YYYY") : "";

  const openNotification = (msg, type = "error", duration = 3000) => {
    dispatch(
      openSnackbar({
        open: true,
        message: msg,
        variant: "alert",
        alert: { color: type },
        close: false,
      })
    );
    setTimeout(() => dispatch(closeSnackbar()), duration);
  };

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files || []);
        console.log("FILES SELECTED:", files); // just to verify

        if (!files.length) return;

        setAttachments((prev) => [...prev, ...files]);

        // allow picking same file again
        e.target.value = "";
};

 const handleRemoveAttachment = (indexToRemove) => {
    setAttachments((prev) =>
        prev.filter((_, index) => index !== indexToRemove)
    );
 };
 
  const handleReject = async () => {
    if (!comment.trim()) {
      openNotification("Please add comments.", "error");
      return;
    }

    try {
        const formData = new FormData();
        formData.append("comment", comment.trim());
        formData.append("type",cardData?.entityType);

        // very important: field name must match [FromForm] List<IFormFile> attachments
        attachments.forEach((file) => {
            formData.append("attachments", file); // repeat same key for multiple files
        });
        if(cardData?.workflowChildStepId)
            formData.append("childStepId", cardData?.workflowChildStepId);

        await rejectWorkItem({
        id: cardData?.entityId,
        body: formData
        }).unwrap();

      openNotification("Task saved successfully.", "success");
      onClose();
    } catch (err) {
      console.error(err);
      openNotification(
        err?.data?.message ||
          err?.error ||
          "Something went wrong while approving.",
        "error"
      );
    }
  };

  const handleSave = async () => {
    if (!comment.trim()) {
      openNotification("Please add comments.", "error");
      return;
    }

    try {
        const formData = new FormData();
        formData.append("comment", comment.trim());
        formData.append("type",cardData?.entityType);

        // very important: field name must match [FromForm] List<IFormFile> attachments
        attachments.forEach((file) => {
            formData.append("attachments", file); // repeat same key for multiple files
        });
        if(cardData?.workflowChildStepId)
            formData.append("childStepId", cardData?.workflowChildStepId);

        await approveWorkItem({
        id: cardData?.entityId,
        body: formData
        }).unwrap();

      if(cardData?.entityType=="Schedule Update")
        localStorage.setItem("progress",1);
      openNotification("Approved successfully.", "success");
      onClose();
    } catch (err) {
      console.error(err);
      openNotification(
        err?.data?.message ||
          err?.error ||
          "Something went wrong while approving.",
        "error"
      );
    }
  };
  const [decision, setDecision] = React.useState(""); // "yes" | "no" | ""

  const handleProceed = async () => {
    // If this step supports reject, decision drives the action
    if (cardData?.isRejectAction) {
      if (decision === "yes") return handleSave();   // approve / proceed
      if (decision === "no") return handleReject();  // send back / reject
      return; // safety
    }

    // Normal step (no rejection option)
    return handleSave();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      sx={{
        "& .MuiDialog-paper": {
          borderRadius: "3px",
          width: "100%",
          margin: "16px",
        },
      }}
    >
      <DialogContent sx={{ p: 0 }}>
        <Grid container spacing={0}>
          {/* HEADER */}
          <Grid
            size={12}
            sx={{
              p: { xs: "10px 15px", md: "15px 20px 13px 20px" },
              bgcolor: "#ECECEC",
            }}
          >
            <Grid container spacing={1}>
              <Grid size={12}>
                <Typography
                  sx={{
                    fontSize: { xs: "22px", md: "27px" },
                    fontWeight: 600,
                    color: "#140F36",
                    fontFamily: "Outfit",
                  }}
                >
                  Task Details
                </Typography>
              </Grid>
              <Grid size={12}>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: 400,
                    color: "#433F5E",
                    fontFamily: "Outfit",
                  }}
                >
                  View the task detail and take actions
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          {/* SUMMARY CARD */}
          <Grid size={12} sx={{ p: { xs: "12px", md: "16px 34px 45px 20px" } }}>
            <Box
              sx={{
                border: "1px solid #ECECEC",
                borderRadius: "3px",
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: "11px",
              }}
            >
              <Box
                sx={{
                  width: { xs: "100%", sm: "48px" },
                  minHeight: { xs: "70px", sm: "160px" },
                  mr: { xs: 0, sm: "15px" },
                  bgcolor: "#6054BB99",
                }}
              />

              <Box sx={{ p: "8px 15px 7px 0px", width: "100%" }}>
                {/* Row 1 */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    justifyContent: "space-between",
                    alignItems: { xs: "flex-start", md: "center" },
                  }}
                >
                  <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
                    <Avatar
                      sx={{
                        width: 30,
                        height: 30,
                        bgcolor: "#6054BB",
                        color: "#fff",
                        fontSize: "14px",
                        fontWeight: "bold",
                        textTransform: "uppercase",
                      }}
                    />
                    <Box sx={{ display: "flex", flexDirection: "column", gap: 0 }}>
                      <Typography
                        sx={{
                          fontSize: "16px",
                          fontWeight: 500,
                          color: "#140F36",
                          fontFamily: "Outfit",
                          whiteSpace: { xs: "normal", md: "nowrap" },
                        }}
                      >
                        {cardData?.ProjectName || ""}
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 400,
                          color: "#433F5E",
                          fontFamily: "Outfit",
                        }}
                      >
                        Description: {schedule?.workflowConfigurationName || ""}
                      </Typography>
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "column", md: "row" },
                      gap: { xs: "4px", md: "12px" },
                      alignItems: { xs: "flex-start", md: "center" },
                      mt: { xs: "10px", md: 0 },
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: 400,
                        color: "#433F5E",
                        fontFamily: "Outfit",
                      }}
                    >
                      Initiated On
                    </Typography>
                    <Box
                      sx={{
                        display: "inline-flex",
                        gap: "8px",
                        alignItems: "center",
                        backgroundColor: "#E7E7EB",
                        p: "2px 6px",
                        borderRadius: "3px",
                      }}
                    >
                      <CiCalendar size={16} color="#5B5772" />
                      <Typography
                        sx={{
                          color: "#5B5772",
                          fontWeight: 600,
                          fontSize: "12px",
                          fontFamily: "Outfit",
                        }}
                      >
                        {getFormattedDate(cardData?.pendingFrom || cardData?.createdDate)}
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                {/* Row 2 */}
                <Box
                  sx={{
                    mt: "12px",
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    justifyContent: "space-between",
                    alignItems: { xs: "flex-start", md: "center" },
                  }}
                >
                  <Box sx={{ display: "flex", gap: "5px", alignItems: "center" }}>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: "#433F5E",
                        fontFamily: "Outfit",
                      }}
                    >
                      Type:
                    </Typography>
                    <Chip
                      sx={{
                        height: "17px",
                        borderRadius: "3px",
                        backgroundColor: "#D0CFD7",
                        px: "6px",
                      }}
                      label={
                        <Box
                          sx={{
                            fontFamily: "Outfit",
                            fontWeight: 600,
                            fontSize: "10px",
                            color: "#433F5E",
                          }}
                        >
                          {cardData?.entityType || ""}
                        </Box>
                      }
                    />
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: { xs: "column", md: "row" },
                      gap: { xs: "4px", md: "12px" },
                      alignItems: { xs: "flex-start", md: "center" },
                      mt: { xs: "10px", md: 0 },
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: 400,
                        color: "#433F5E",
                        fontFamily: "Outfit",
                      }}
                    >
                      Due On
                    </Typography>
                    <Box
                      sx={{
                        display: "inline-flex",
                        gap: "8px",
                        alignItems: "center",
                        backgroundColor: "#E7E7EB",
                        p: "2px 6px",
                        borderRadius: "3px",
                      }}
                    >
                      <CiCalendar size={16} color="#5B5772" />
                      <Typography
                        sx={{
                          color: "#5B5772",
                          fontWeight: 600,
                          fontSize: "12px",
                          fontFamily: "Outfit",
                        }}
                      >
                        {getFormattedDate(cardData?.dueDate)}
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                {/* Row 3 */}
                <Box
                  sx={{
                    mt: "15px",
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    justifyContent: "space-between",
                    alignItems: { xs: "flex-start", md: "center" },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "5px",
                      alignItems: "flex-start",
                    }}
                  >
                    <Box sx={{ display: "flex", gap: "8px", alignItems: "center" }}>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          color: "#433F5E",
                          fontFamily: "Outfit",
                        }}
                      >
                        Initiated By:
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          color: "#433F5E",
                          fontFamily: "Outfit",
                        }}
                      >
                        {cardData?.createdBy || "Shanti Nautiyal"}
                      </Typography>
                    </Box>
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      gap: "12px",
                      alignItems: "center",
                      mt: { xs: "10px", md: 0 },
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: "#433F5E",
                        fontFamily: "Outfit",
                      }}
                    >
                      Workflow status
                    </Typography>
                    <StatusBadge status={cardData?.workflowStatus || ""} />
                  </Box>
                </Box>

                {/* Row 4 */}
                <Box
                  sx={{
                    mt: "8px",
                    display: "flex",
                    flexDirection: { xs: "column", md: "row" },
                    justifyContent: "space-between",
                    alignItems: { xs: "flex-start", md: "center" },
                  }}
                >
                  <Box sx={{ display: "flex", gap: "8px", alignItems: "center" }}>
                    <Typography
                      sx={{
                        fontSize: "12px",
                        color: "#0A65E4",
                        fontFamily: "Outfit",
                        cursor: "pointer",
                      }}
                    >
                      
                    </Typography>
                  </Box>
                        {!isDocumentsLoading && !documentError && documents?.length > 0 && (
                            <Box
                                sx={{
                                    mt: "6px",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "4px",
                                    width: "100%",
                                }}
                                >
                                {documents.map((att) => (
                                    <Box
                                    key={att.id}
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        borderRadius: "3px",
                                        border: "1px solid #ECECEC",
                                        p: "4px 8px",
                                        bgcolor: "#FFFFFF",
                                        gap: 1,
                                        maxWidth: 320,
                                    }}
                                    >
                                    <Box
                                        sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                        }}
                                    >
                                        <Box
                                        sx={{
                                            width: 22,
                                            height: 26,
                                            borderRadius: "3px",
                                            bgcolor: "#E7F0FD",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontSize: "9px",
                                            fontWeight: 600,
                                            color: "#0A65E4",
                                            fontFamily: "Outfit",
                                        }}
                                        >
                                        {(att.fileType || "file").toUpperCase().slice(0, 4)}
                                        </Box>
                                        <Typography
                                        sx={{
                                            fontSize: "12px",
                                            fontWeight: 500,
                                            color: "#2C274A",
                                            fontFamily: "Outfit",
                                            maxWidth: 200,
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                        }}
                                        >
                                        {att.fileName || "Attachment"}
                                        </Typography>
                                    </Box>

                                        <Button
                                        size="small"
                                        component="a"
                                        href={`${API_BASE_URL}${att.filePath}`}   // 👈 your download link
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        sx={{
                                            textTransform: "none",
                                            fontSize: "11px",
                                            fontFamily: "Outfit",
                                            color: "#0A65E4",
                                            minWidth: "auto",
                                        }}
                                        >
                                        View
                                        </Button>

                                    </Box>
                                ))}
                                </Box>
                            )}


                  <Box
                    sx={{
                      display: "flex",
                      gap: "12px",
                      alignItems: "center",
                      mt: { xs: "10px", md: 0 },
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: "#433F5E",
                        fontFamily: "Outfit",
                      }}
                    >
                      Current Stage: 
                    </Typography>
                    <StatusBadge status={cardData?.currentStep || ""} />
                  </Box>
                </Box>

                {/* Row 3 */}
                <WorkflowMetaCard
                  cardData={scheduleData?.data}
                  StatusBadge={StatusBadge}
                  title="Metadata"
                  columns={2}
                  hiddenKeys={["DesignTrackerId"]} // optional
                  labelMap={{
                    DrgNo: "Drawing No",
                    TargetDate: "Target Date",
                  }}
                />
              </Box>
            </Box>
          </Grid>

          {/* BODY: HISTORY + ACTION */}
          <Grid size={12}>
            <Grid
              container
              rowSpacing={{ xs: 2, md: 0 }}
              columnSpacing={3}
              sx={{ p: { xs: "0px 16px 22px 16px", md: "0px 34px 22px 20px" } }}
            >
              {/* LEFT: HISTORY */}
              <Grid size={{ xs: 12, md: 6 }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "14px",
                    alignItems: "flex-start",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 500,
                      color: "#2C274A",
                      fontFamily: "Outfit",
                    }}
                  >
                    Document Activity
                  </Typography>
                  <Box
                    sx={{
                      p: "6px 10px",
                      bgcolor: "#E7F0FD",
                      borderRadius: "3px",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "12px",
                        fontWeight: 500,
                        color: "#0A65E4",
                        fontFamily: "Outfit",
                      }}
                    >
                      History
                    </Typography>
                  </Box>
                </Box>

                <Box
                  sx={{
                    mt: "10px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "14px",
                    alignItems: "flex-start",
                    //maxHeight: 420,
                    pr: 1,
                    overflowY: "auto",
                  }}
                >
                  {/* Loading */}
                  {isHistoryLoading && (
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: 400,
                        color: "#726F86",
                        fontFamily: "Outfit",
                      }}
                    >
                      Loading history...
                    </Typography>
                  )}

                  {/* Error */}
                  {historyError && !isHistoryLoading && (
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: 400,
                        color: "#FF383C",
                        fontFamily: "Outfit",
                      }}
                    >
                      Failed to load history.
                    </Typography>
                  )}

                  {/* Empty */}
                  {!isHistoryLoading &&
                    !historyError &&
                    workflowSteps.length === 0 &&  (
                      <Typography
                        sx={{
                          fontSize: "14px",
                          fontWeight: 400,
                          color: "#726F86",
                          fontFamily: "Outfit",
                        }}
                      >
                        No history available for this task yet.
                      </Typography>
                    )}

                  {/* Items */}
                 {!isHistoryLoading &&
                    !historyError &&
                    workflowSteps.length > 0 &&
                    [...workflowSteps]
                    .reverse() 
                    .map((item, index) => {
                      
                        console.log('length', workflowSteps.length);
                        console.log('index', index);
                    //workflowSteps.map((item, index) => {
                        const userName =
                        item.approverRoleName || item.performedBy || "Unknown user";

                        const actionText = item.action ;
                        const createdOn =
                        item.completedDate || item.createdOn || item.timestamp;
                        const timeAgo = createdOn ? moment(createdOn).fromNow() : "";

                        const stepAttachments = item.attachments || [];
                        const childStepApprovals = item.childStepApprovals || [];
                        const wofkflowStep = item.workflowStep || "";
                        const isRejected = item.actionTaken === "Rejected";


                        const initials = userName
                        .split(" ")
                        .filter(Boolean)
                        .map((n) => n[0])
                        .join("")
                        .toUpperCase()
                        .slice(0, 2);

                        // 👇 What to show as the main line
                        const primaryText = item.comment || actionText;
                        //if(item.status=="Completed")
                        {
                        return (
                        <Box
                            key={item.id || index}
                            sx={{
                            display: "flex",
                            gap: "16px",
                            width: "100%",
                            }}
                        >
                            <Avatar
                            sx={{
                                width: 28,
                                height: 28,
                                bgcolor: "#140F36",
                                color: "#fff",
                                fontSize: "14px",
                                fontWeight: "bold",
                                textTransform: "uppercase",
                                mt: "4px",
                            }}
                            >
                            {initials}
                            </Avatar>

                            <Box sx={{ flex: 1, display: "flex", flexDirection: "column" }}>
                            {/* 1️⃣ Main line: comment/action */}
<Box sx={{ display: "flex", alignItems: "center", gap: "6px" }}>
  {isRejected && (
    <CancelOutlinedIcon
      sx={{
        fontSize: 16,
        color: "#E53935", // rejection red
      }}
    />
  )}

  <Typography
    sx={{
      fontSize: "14px",
      fontWeight: 500,
      fontFamily: "Outfit",
      color: isRejected ? "#E53935" : "#2C274A",
    }}
  >
    {primaryText}
  </Typography>
</Box>

                            {/* 2️⃣ Meta line: workflow step */}
                            <Typography
                                sx={{
                                mt: "2px",
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "#726F86",
                                fontFamily: "Outfit",
                                }}
                            >
                                {wofkflowStep}
                            </Typography>
                            {/* 2️⃣ Meta line: user + time */}
                            <Typography
                                sx={{
                                mt: "2px",
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "#726F86",
                                fontFamily: "Outfit",
                                }}
                            >
                                {userName} &bull; {timeAgo}
                            </Typography>

                            {/* 3️⃣ Attachments (if any) */}
                            {stepAttachments.length > 0 && (
                                <Box
                                sx={{
                                    mt: "6px",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "4px",
                                    width: "100%",
                                }}
                                >
                                {stepAttachments.map((att) => (
                                    <Box
                                    key={att.id}
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        borderRadius: "3px",
                                        border: "1px solid #ECECEC",
                                        p: "4px 8px",
                                        bgcolor: "#FFFFFF",
                                        gap: 1,
                                        maxWidth: 320,
                                    }}
                                    >
                                    <Box
                                        sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        gap: 1,
                                        }}
                                    >
                                        <Box
                                        sx={{
                                            width: 22,
                                            height: 26,
                                            borderRadius: "3px",
                                            bgcolor: "#E7F0FD",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontSize: "9px",
                                            fontWeight: 600,
                                            color: "#0A65E4",
                                            fontFamily: "Outfit",
                                        }}
                                        >
                                        {(att.fileType || "file").toUpperCase().slice(0, 4)}
                                        </Box>
                                        <Typography
                                        sx={{
                                            fontSize: "12px",
                                            fontWeight: 500,
                                            color: "#2C274A",
                                            fontFamily: "Outfit",
                                            maxWidth: 200,
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                        }}
                                        >
                                        {att.fileName || "Attachment"}
                                        </Typography>
                                    </Box>

                                        <Button
                                        size="small"
                                        component="a"
                                        href={`${API_BASE_URL}${att.filePath}`}   // 👈 your download link
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        sx={{
                                            textTransform: "none",
                                            fontSize: "11px",
                                            fontFamily: "Outfit",
                                            color: "#0A65E4",
                                            minWidth: "auto",
                                        }}
                                        >
                                        View
                                        </Button>

                                    </Box>
                                ))}
                                </Box>
                            )}
                                {/* 4️⃣ Child approvals (if any) */}
                                {childStepApprovals.length > 0 && (
                                <Box
                                    sx={{
                                    mt: 1.5,
                                    pl: 2.5,
                                    borderLeft: "2px solid #E0E0EA",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 1,
                                    }}
                                >
                                    {childStepApprovals.map((child, childIndex) => {
                                    const childUserName =
                                        child.approverName || child.roleName || "Unknown approver";
                                    const childStepName = child.childStepName || "";
                                    const childAction = child.comment || "Reviewed";
                                    const childPrimaryText = child.comment || childAction;
                                    const childCreatedOn = child.approvedDate;
                                    const childTimeAgo = childCreatedOn
                                        ? moment(childCreatedOn).fromNow()
                                        : "";

                                    return (
                                        <Box
                                        key={child.id || `${item.id}-child-${childIndex}`}
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            gap: 0.5,
                                        }}
                                        >
                                        {/* child main line */}
                                        <Typography
                                            sx={{
                                            fontSize: "13px",
                                            fontWeight: 500,
                                            color: "#3A345C",
                                            fontFamily: "Outfit",
                                            }}
                                        >
                                            {childPrimaryText}
                                        </Typography>
                                        {/* child meta */}
                                        <Typography
                                            sx={{
                                            fontSize: "11px",
                                            fontWeight: 400,
                                            color: "#8A879C",
                                            fontFamily: "Outfit",
                                            }}
                                        >
                                            {childStepName}
                                        </Typography>
                                        
                                        {/* child meta */}
                                        <Typography
                                            sx={{
                                            fontSize: "11px",
                                            fontWeight: 400,
                                            color: "#8A879C",
                                            fontFamily: "Outfit",
                                            }}
                                        >
                                            {childUserName}
                                            {childTimeAgo && <> &bull; {childTimeAgo}</>}
                                            {child.status && <> &bull; {child.status}</>}
                                        </Typography>
                                        </Box>
                                    );
                                    })}
                                </Box>
                                )}


                            {/* befre this*/}
                            </Box>
                        </Box>
                        );
                        }
                    })}

                </Box>
              </Grid>

              {/* RIGHT: REVIEW & PROCEED */}
              <Grid size={{ xs: 12, md: 6 }}>
                {/* Section header */}
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "6px",
                    alignItems: "flex-start",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "16px",
                      fontWeight: 500,
                      color: "#2C274A",
                      fontFamily: "Outfit",
                    }}
                  >
                    Review &amp; Proceed
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: 400,
                      color: "#726F86",
                      fontFamily: "Outfit",
                    }}
                  >
                    
                    {cardData?.currentStep ||""}
                    {/* This step has a single action:{" "}
                    <strong>Save &amp; Proceed</strong>. */}
                  </Typography>
                </Box>

                {/* Comment + attachment */}
                <Box
                  sx={{
                    display: "flex",
                    gap: "14px",
                    mt: "18px",
                    alignItems: "flex-start",
                  }}
                >
                  <Avatar
                    sx={{
                      width: 40,
                      height: 40,
                      bgcolor: "#140F36",
                      color: "#fff",
                      fontSize: "16px",
                      fontWeight: "bold",
                      textTransform: "uppercase",
                    }}
                  />
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "10px",
                      flex: 1,
                    }}
                  >
                    <TextField
                      label="Comments"
                      placeholder="Add your comments for this action..."
                      value={comment}
                      onChange={(e) => setComment(e.target.value)}
                      multiline
                      minRows={4}
                      fullWidth
                      InputLabelProps={{
                        sx: {
                          fontFamily: "Outfit, sans-serif",
                          fontSize: "14px",
                        },
                      }}
                      inputProps={{
                        sx: {
                          fontFamily: "Outfit, sans-serif",
                          fontSize: "14px",
                        },
                      }}
                    />

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "6px",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: "13px",
                          fontWeight: 500,
                          color: "#2C274A",
                          fontFamily: "Outfit",
                        }}
                      >
                        Attachments (optional)
                      </Typography>
                      <Box
                        sx={{
                          display: "flex",
                          gap: "8px",
                          alignItems: "center",
                          flexWrap: "wrap",
                        }}
                      >
                        <Button
                          variant="outlined"
                          component="label"
                          sx={{
                            textTransform: "none",
                            fontSize: "13px",
                            fontFamily: "Outfit",
                            borderRadius: "3px",
                            px: 2,
                            py: 0.5,
                          }}
                        >
                          Upload file
                          <input type="file" hidden multiple onChange={handleFileChange} />
                        </Button>

                        {attachments.map((file, index) => (
                            <Box
                                key={file.name + index}
                                sx={{
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "8px",
                                backgroundColor: "#F5F5F5",
                                borderRadius: "3px",
                                px: 2,
                                py: 0.5,
                                }}
                            >
                                <Typography
                                sx={{
                                    fontSize: "12px",
                                    fontFamily: "Outfit",
                                    color: "#433F5E",
                                    maxWidth: 200,
                                    whiteSpace: "nowrap",
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                }}
                                >
                                {file.name}
                                </Typography>
                                <Button
                                size="small"
                                onClick={() => handleRemoveAttachment(index)}
                                sx={{
                                    textTransform: "none",
                                    fontSize: "11px",
                                    minWidth: "auto",
                                    color: "#F15744",
                                }}
                                >
                                Remove
                                </Button>
                            </Box>
                        ))}
                      </Box>
                    </Box>
                  </Box>
                </Box>

                {/* Footer actions */}
                <Box
  sx={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    mt: { xs: "28px", md: "48px" },
    flexDirection: { xs: "column-reverse", md: "row" },
    gap: { xs: "16px", md: 0 },
  }}
>
  {/* Close */}
  <Button
    onClick={onClose}
    sx={{
      fontSize: "14px",
      fontWeight: 500,
      color: "#F15744",
      fontFamily: "Outfit",
      width: { xs: "100%", md: "auto" },
      textTransform: "none",
    }}
  >
    Close
  </Button>

  {/* Right side actions */}
  <Box
    sx={{
      display: "flex",
      gap: "14px",
      alignItems: "center",
      flexDirection: { xs: "column", md: "row" },
      width: { xs: "100%", md: "auto" },
    }}
  >
    {/* Decision dropdown only when reject action is allowed */}
    {cardData?.isRejectAction && (
      <FormControl
        size="small"
        sx={{
          width: { xs: "100%", md: 220 },
        }}
      >
        <Select
          value={decision}
          onChange={(e) => setDecision(e.target.value)}
          displayEmpty
          sx={{
            borderRadius: "3px",
            fontFamily: "Outfit",
            fontSize: "14px",
            height: 46,
            bgcolor: "#fff",
          }}
          renderValue={(selected) => {
            if (!selected) {
              return (
                <Typography sx={{ color: "#726F86", fontFamily: "Outfit", fontSize: "14px" }}>
                  Go Ahead (Yes/No)
                </Typography>
              );
            }
            return selected === "yes" ? "Yes" : "No";
          }}
        >
          <MenuItem value="yes">Yes</MenuItem>
          <MenuItem value="no">No</MenuItem>
        </Select>
      </FormControl>
    )}

    {/* Single Proceed button */}
    <Button
      onClick={handleProceed}
      disabled={
        isLoading || isLRejectLoading || (cardData?.isRejectAction && !decision)
      }
      sx={{
        backgroundColor: "#00344C",
        color: "#fff",
        fontFamily: "Outfit",
        fontWeight: 500,
        fontSize: "14px",
        lineHeight: "100%",
        letterSpacing: 0,
        width: { xs: "100%", md: "auto" },
        px: "20px",
        py: "15px",
        borderRadius: "3px",
        textTransform: "none",
        "&:hover": { backgroundColor: "#00344C" },
        "&.Mui-disabled": { opacity: 0.6, color: "#fff" },
      }}
    >
      {isLoading || isLRejectLoading ? "Saving..." : "Proceed"}
    </Button>
  </Box>
</Box>

                {/* <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    mt: { xs: "28px", md: "48px" },
                    flexDirection: { xs: "column-reverse", md: "row" },
                    gap: { xs: "16px", md: 0 },
                  }}
                >
                    <Button
                      onClick={onClose}
                      sx={{
                        fontSize: "14px",
                        fontWeight: 500,
                        color: "#F15744",
                        fontFamily: "Outfit",
                        width: { xs: "100%", md: "auto" },
                      }}
                    >
                      Close
                    </Button>
                  {cardData?.isRejectAction && (<Button 
                    variant="outlined"
                    component="label"
                    label={isLRejectLoading ? "Saving..." : "Send Back"}
                    onClick={handleReject}
                      sx={{
                          textTransform: "none",
                          color: "#00344C",
                          fontSize: "14px",
                          lineHeight: "100%",
                          fontFamily: "Outfit, sans-serif",
                          borderRadius: "3px",
                          fontWeight: 500,
                          px: "20px",
                          py: "15px",
                      }}>
                      Send Back
                  </Button>)}
                  <Box
                    sx={{
                      display: "flex",
                      gap: "20px",
                      alignItems: "center",
                      flexDirection: { xs: "column", md: "row" },
                      width: { xs: "100%", md: "auto" },
                    }}
                  >
                    <CustomButton
                      label={isLoading ? "Saving..." : "Proceed Ahead"}
                      color="primary"
                      disabled={isLoading}
                      onClick={handleSave}
                      sx={{
                        backgroundColor: "#00344C",
                        fontFamily: "Outfit",
                        fontWeight: 500,
                        fontSize: "14px",
                        lineHeight: "100%",
                        letterSpacing: 0,
                        width: { xs: "100%", md: "auto" },
                      }}
                    />
                  </Box>
                </Box> */}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default ViewSchedule;
